import { combineReducers } from 'redux';

import habitTrackingDashboardUiReducer from './habitTrackingDashboardUiReducer';
import habitTrackingDashboardDataReducer from './habitTrackingDashboardDataReducer';

export default combineReducers({
  ui: habitTrackingDashboardUiReducer,
  data: habitTrackingDashboardDataReducer,
});
